import * as React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link, useNavigate } from "react-router-dom";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import TextField from '@mui/material/TextField';
// redux
import { useSelector, useDispatch } from 'react-redux';
import WebService from '@util/webService';
import {emailRegex, getAction, printVariable} from '@util/helper';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

import '@scss/App.scss'
import { isAdmin } from '@util/helper';
import {FormHelperText} from "@mui/material";
import ConfirmDialog from "@components/ConfirmDialog";
import useIndicator from "@hooks/useIndicator";
import useAlert from "@hooks/useAlert";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  padding: theme.spacing(1),
  textAlign: 'center',
  borderBottom: '1 solid #ccc',
  boxShadow:{},
  color: theme.palette.text.secondary,
}));

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const WelcomeIndexPage = () => {
  const navigate = useNavigate()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const account = useSelector(state => state.accountReducer)

  const [loginId, set_loginId] = useState(account?.user?.loginId ?? '')
  const [emailError, set_emailError] = useState('')
  const {alert, renderAlert} = useAlert()
  const [certNum, set_certNum] = useState('')
  const [emailCertId, set_emailCertId] = useState('')
  const [loaded, set_loaded] = useState(false)

  const handleLoginId = (e) => {
    const v = e.target.value.trim()
    if(!emailRegex.test(v) ){
      set_emailError('올바른 이메일 형식이 아닙니다.')
    }
    else {
      set_emailError('')
    }
    set_loginId(v)
  }

  const canSubmit = () => {
    return emailRegex.test(loginId)
  }

  const canCert = () => {
    return certNum.length === 6
  }

  const canChange = async () =>{
    // TODO
    // const url = encodeURI(`/public/email/${loginId}/${account?.user?.id}`)
    const url = encodeURI(`/public/email/${loginId}/${account.user.id}`)

    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }
    return true
  }

  const onCert = async() => {
    const url = `/user/email/cert/${emailCertId}/${certNum}`
    const resp = await WebService.post(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('인증되었습니다.', () => {
      navigate('/welcome/manager')
    })
    
  }

  const onSubmit = async () => {
    const isUnq = await canChange()
    if(!isUnq) {
      return
    }

    const url = encodeURI(`/user/email/cert`)
    const data = {
      userId: account.user.id,
      email: loginId,
    }
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    closeIndicator()
    const repMessage = JSON.parse(resp.repMessage)
    const emailCertId = repMessage.emailCertId
    set_emailCertId(emailCertId)
    alert('이메일을 발송하였습니다. 메일 수신함을 확인하세요.')
  }


  const fetchEmailCertId = async() => {
    const url = `/user/email/cert/${account.user.loginId}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return repMessage.emailCertId
  }

  const onLoad = async() =>{
    if(account?.user) {
      if(account.user.emailCertYn === 'Y') {
        navigate('/welcome/manager')
      }
      else {
        const emailCertId = await fetchEmailCertId()
        if(emailCertId) {
          set_emailCertId(emailCertId)
        }
        
      }
    }
    else {
      navigate('/login')
    }
    set_loaded(true)
  }

  useEffect(() => {
    onLoad()
  },[account.user])

  return (
    <>
    {
      loaded ? (
        <Box sx={{minHeight: "100vh", display:'flex',flexGrow: 1, justifyContent:'center', alignItems:'center', }}>

          <Grid container spacing={4} sx={{padding:10}}>
            <Grid item xs={12}>
              <div>
                <Typography variant="h3" align='center'>
                  스쿨매니저에 오신 것을 환영합니다.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div>
                <Typography variant="h6" align='center'>
                  이메일 인증이 완료되지 않았습니다.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" align='center'>
                가입하신 이메일의 받은편지함을 확인하여 인증을 완료해 주세요.
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
              <TextField 
                label='인증번호'
                sx={{mr:5}}
                value={certNum} 
                inputProps={{
                  maxLength:6,
                  onInput: (e) => {
                    const value = e.target.value;
                    // Remove any non-numeric characters from the input
                    const numericValue = value.replace(/[^0-9]/g, '');
                    e.target.value = numericValue;
                  },
                }}
                onChange ={(e) => {
                  set_certNum(e.target.value)
                 }}
              />  
              {<Button d size='lg' color={'primary'} disabled={!canCert()} onClick={onCert}>인증하기</Button>}
            </Grid>
            <Grid item xs={12} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
              <div style={{display:'flex', alignItems:'flex-start', flexDirection:'column'}}>
                <Typography variant="h7" align='center'>
                  <CheckOutlinedIcon /> 인증 메일을 재발송 할 수 있습니다.
                </Typography>
                <Typography variant="h7" align='center'>
                  <CheckOutlinedIcon /> 아래에서 이메일 주소를 수정할 수 있습니다.
                </Typography>
                <Typography variant="h7" align='center'>
                  <CheckOutlinedIcon /> 인증된 이메일로 로그인하실 수 있습니다.
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
              <TextField
                label='아이디(이메일)'
                sx={{marginRight:5, width:'20em'}}
                value={loginId}
                onChange={(e) => {
                  handleLoginId(e)
                }}
              />
              <ConfirmDialog
                btn={<Button size='lg' color={'primary'} disabled={!canSubmit()}>이메일 (재)발송</Button>}
                title={'알림'}
                content={'이메일을 발송 하시겠습니까?'}
                bc={'primary'}
                preHandle={ async () => {
                  return true
                }}
                perform={() => {
                  onSubmit()
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
              <FormHelperTexts className='center'>{emailError}</FormHelperTexts>
            </Grid>
          </Grid>
          {renderIndicator()}
          {renderAlert()}

        </Box>

      ) : null
    }
    </>
  )
}

export default WelcomeIndexPage
